<i18n>
{
  "en":{
    "faq": "Frequently Asked Questions",
    "contact": "Contacts",
    "leave_faq": "OK"
  },
  "zhHant":{
    "faq": "常見問題",
    "contact": "聯絡我們",
    "leave_faq": "OK"
  },
  "ja":{
    "faq":"よくある質問",
    "contact": "お問い合わせ",
    "leave_faq": "OK"
  },
  "ko":{
    "faq": "자주 묻는 질문 QnA",
    "contact": "문의",
    "leave_faq": "OK"
  }
}
</i18n>

<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 sm8 offset-sm2>
        <v-card>
          <v-toolbar color="cyan" dark>
            <v-toolbar-title>{{ $t('faq') }}</v-toolbar-title>
          </v-toolbar>

          <v-expansion-panel v-model="panelLayer1">
            <v-expansion-panel-content v-for="(qa, qaId) in qaList" :key="qaId">
              <template v-slot:header>
                <v-flex>
                  <v-icon>{{ qa.icon }}</v-icon>
                  <span
                    :style="{
                      color: '#1976d2',
                      'font-size': '22px',
                      'padding-left': '6px'
                    }"
                    >{{ qa.category[$i18n.locale] }}</span
                  >
                </v-flex>
              </template>
              <v-flex v-for="(content, contentId) in qa.contents" :key="contentId">
                <v-expansion-panel :value="$route.hash === content.expandKey ? 0 : null">
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <v-card-title
                        :style="{
                          'padding-top': '0px',
                          'padding-bottom': '0px'
                        }"
                      >
                        <span class="font-weight-bold" :style="{ color: '#85929E', 'font-size': '20px' }">{{
                          content.question[$i18n.locale]
                        }}</span>
                      </v-card-title>
                    </template>

                    <v-card>
                      <v-card-text
                        :style="{
                          'padding-top': '0px',
                          'padding-left': '36px'
                        }"
                      >
                        <span :style="{ 'white-space': 'pre-wrap' }" v-html="$t(content.answer[$i18n.locale])" />
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card>

        <v-card class="elevation-0 transparent">
          <v-card-title primary-title class="layout justify-center">
            <div class="headline">{{ $t('contact') }}</div>
          </v-card-title>
          <ContactInfo></ContactInfo>
        </v-card>

        <v-btn @click="back" color="info" block>{{ $t('leave_faq') }}</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ContactInfo from '../components/ContactInfo';

export default {
  name: 'support',
  components: {
    ContactInfo
  },
  data: () => {
    return {
      panelLayer1: null,
      qaList: [
        {
          icon: 'mdi-calendar-account',
          category: {
            en: 'Subscriptions',
            zhHant: '訂閱',
            ja: 'ご購入',
            ko: '라이센스 구독'
          },
          contents: [
            {
              question: {
                en: 'What is XRobotmon license model?',
                zhHant: '如何訂閱XRobotmon？',
                ja: 'Xロボットモンはどのように購入できますか？',
                ko: '어떻게 XRobotmon 라이센스를 구독할 수 있나요?'
              },
              answer: {
                en:
                  'XRobotmon is a subscription service. It will renew automatically, so that you do not have to manually resubscribe it every 30 days. <br><br>You can cancel your subscription any time.',
                zhHant:
                  'XRobotmon是訂閱制服務，訂閱成功後會在快到期時續約，您不必手動再次付款呦。<br><br>您可以隨時取消訂閱。',
                ja:
                  'お支払い方法は、クレジットカードまたはPayPalからお選びいただけます。Xロボットモンは自動更新型のサブスクリプションサービスです。有効期限を迎えると自動的に更新され、料金が請求されます。更新をご希望でない場合は、［有料版］ボタンからライセンスの状況をご確認のうえ、いつでも解約のお手続きができます。',
                ko:
                  'XRobotmon은 구독제입니다. 구독이 완료된 후에는 자동으로 결제됩니다. 수동으로 다시 결제할 필요가 없습니다.'
              }
            },
            {
              question: {
                en: 'How to cancel my subscription?',
                zhHant: '如何取消自動扣款呢？',
                ja: '自動更新を停止するにはどうすればよいですか？',
                ko: '어떻게 자동결제를 취소할 수 있나요?'
              },
              answer: {
                en:
                  "We just added the self-unsubscribe feature! From now on, you can tap 'STANDARD' to check your subscription status, and if you need, unsubscribe from there.",
                zhHant:
                  '我們的自助退訂功能已經完成摟！可以自己點擊 “標準版” 按鈕先查看現在的訂閱狀態，然後可以再點擊退訂按鈕來退訂喔！',
                ja:
                  '［有料版］ボタンを押すとライセンスの状況が表示され、その画面からいつでもご自身で解約のお手続きができます。なお、解約後も有効期限までは引き続きご利用いただけます。',
                ko:
                  '언제라도 구독을 취소할 수 있습니다. 만약 신용카드로 결제를 등록했다면, XRobotmon에 등록된 이메일 혹은 페이스북을 통해 문의주시면 바로 도와드리겠습니다. 구독 취소 이후 자동 결제가 되지 않습니다. 라이센스 기간이 만료될 때까지는 이용할 수 있습니다. 페이팔을 통해 결제했다면, 페이팔을 통해 자동 결제를 취소하거나, 직접 문의를 통해 구독을 취소할 수 있습니다.'
              }
            },
            {
              question: {
                en: 'Can I play multiple Line: TsumTsum accounts using one XRobotmon?',
                zhHant: '我的同個XRobotmon可以同時玩多個不同的Line: TsumTsum帳號嗎？',
                ja: 'Xロボットモンで複数のツムツムアカウントを同時に使えますか？',
                ko: '하나의 XRobotmon계정에서 여러 개의 게임 계정을 동시에 자동 플레이할 수 있나요?'
              },
              answer: {
                en:
                  'You can either:  <br><br>1) switch the Line account in the XRobotmon config page manually every couple of days, or  <br><br>2) in the XRobotmon page you are currently in, activate 2nd license and config it for the second line account. <br><br>XRobotmon is capable of running multiple Line accounts at the same time for those having multiple accounts.  hint: even if you purchased 1st license, you can still apply for free trial for your 2nd account ;)',
                zhHant:
                  '同一個XRobotmon帳號有同時管理多個授權的功能，而一個授權在同一時間下只可以執行一個帳號。因此如需要同時掛兩個帳號，請直接再訂閱第二個授權就可以了。另外您也可以先點一下試用來試試看第二個授權！',
                ja:
                  '1つのライセンスにつき、1つのLINEアカウントをご利用いただけます。<br><br>複数のツムツムアカウントを同時にご利用になりたい場合は、ライセンスをもう1つご購入いただくか、無料トライアルをお申し込みください。',
                ko:
                  '같은 XRobotmon 계정은 여러개의 라이센스를 동시에 관리하고 플레이할 수 있는 기능을 가지고 있습니다. 하나의 라이센스는 같은 시간동안 하나의 게임 계정만 할 수 있습니다. 따라서, 두 개의 게임 계정을 동시에 자동 플레이하고 싶다면 두개의 라이센스를 결제하시면 됩니다.'
              }
            },
            {
              question: {
                en: 'Any example how to use the referall bonus?',
                zhHant: '能不能舉例說明一下推薦碼獎勵？',
                ja: '友達紹介コードの使い方を教えてください。',
                ko: '추천코드 등록 보너스에 대해 설명해주세요.'
              },
              answer: {
                en:
                  "Example: John is currently having a paid XRobotmon license and would like to invite his friend Harry to give it a try. Once Harry has free-tried and would like to purchase a XRobotmon license, Harry can input John's referral code during subscribing. Once this subscription completed, the licenses of both John and Harry would both be extended for five days.<br><br>Meanwhile, Oliver, another friend of John, can input John's referral code during subscribing XRobotmon, and extending the licenses of John & Oliver for another five days. That being said, John's license will be exteded for ten extra days. Harry and Oliver would get five extra days each.",
                zhHant:
                  '例如：A現在正在使用付費版的XRobotmon並推薦了朋友B來試用看看，當朋友B試用過後覺得不錯也想訂閱XRobotmon時，B可以在訂閱時輸入A的推薦碼。訂閱完成後此時A與B的授權將延長5天。另外，如果A的朋友C也想購買XRobotmon，則C亦可輸入A的推薦碼，並且A與C的授權將延長5天。換句話說，A的授權將總共延長10天。而A的朋友B和C的授權將延長至5天。',
                ja:
                  '例：AさんがXロボットモンの有料版をご利用中で、お友達のBさんが新規に購入する際、BさんがAさんの紹介コードを入力すると、AさんとBさんの両方のライセンスが5日間延長されます。<br><br>さらに、Aさんの別のお友達Cさんも同じようにAさんの紹介コードを利用すると、AさんとCさんのライセンスがそれぞれ5日間延長されます。つまり、Aさんのライセンスは合計10日間、BさんとCさんはそれぞれ5日間延長されることになります。',
                ko:
                  '예를 들어 A는 XRobotmon을 결제하여 이용중이며, 친구B를 추천해주어 친구B가 결제를 할때 A에게 받은 추천코드를 입력하면 됩니다. 결제가 완료되면 A와 B의 라이센스 기간이 5일 추가됩니다. 또한 A의 친구 C도 XRobotmon을 구매한다면, C도 A에게 받은 추천코드를 입력할 수 있으며, 이 경우에도 A와 C의 라이센스 기간이 5일 추가됩니다. 다시말해 A가 받은 보너스는 총 10일입니다. A의 친구 B와 C는 각각 5일까지 추가됩니다.'
              }
            }
          ]
        },
        {
          icon: 'mdi-credit-card-outline',
          category: {
            en: 'Payment',
            zhHant: '付費',
            ja: 'お支払い',
            ko: '결제 진행'
          },
          contents: [
            {
              question: {
                en: 'How does the subscription auto-renew itself?',
                zhHant: '自動扣款是如何進行的呢?',
                ja: '自動更新の仕組みについて教えてください。',
                ko: '자동결제는 어떻게 진행되나요?'
              },
              answer: {
                en:
                  'At the end of each billing period, XRobotmon charges your saved payment method and extends your license for another period: every 30 days on a monthly plan, or once a year on a yearly plan.',
                zhHant: '每次訂閱期間結束時，會自動從您設定的付款方式扣款，並將授權延長一個訂閱期間：月繳方案每30天一次，年繳方案每年一次。',
                ja:
                  'Xロボットモンは自動更新型のサブスクリプションサービスです。ご契約期間が終わるたびに、ご登録のお支払い方法で次の期間分の料金が自動で決済され、ライセンスの有効期限も同じ期間だけ延長されます。更新のタイミングは、月額プランなら30日ごと、年額プランなら1年ごとです。',
                ko: '구독 기간이 끝날 때마다 등록된 결제 수단으로 다음 기간의 요금이 자동 결제되고, 라이센스가 같은 기간만큼 연장됩니다. 월 구독은 30일마다, 연 구독은 1년마다 갱신됩니다.'
              }
            }
          ]
        },
        {
          icon: 'mdi-wrench-outline',
          category: {
            en: 'Setting',
            zhHant: '設定',
            ja: '設定',
            ko: '설정'
          },
          contents: [
            {
              question: {
                en: 'Does XRobotmon support iPhone?',
                zhHant: 'iPhone 可以用嗎?',
                ja: 'XロボットモンはiPhoneでも使えますか？',
                ko: '아이폰에서도 사용 가능한가요?'
              },
              answer: {
                en:
                  'Yes, XRobotmon works with iPhone perfectly. <br><br>Please check if your iPhone is iOS 12.2 or later to ensure the best live streaming quality',
                zhHant: 'iPhone也可以使用XRbotmon唷，使用時請將您的iOS版本升級到12.2或以上。',
                ja:
                  'Xロボットモンは、お手元のスマートフォンではなく、インターネット上のロボットがゲームを自動でプレイするサービスです。そのため、iPhone・Androidのどちらからでもご利用いただけます。ウェブブラウザを開くだけで、外出先でも設定や状況の確認が行えます。',
                ko: '아이폰에서도 XRobotmon을 사용할 수 있습니다. iOS버전을 12.2 이상으로 업그레이드 해야합니다.'
              }
            },
            {
              question: {
                en: 'What is the limitation for free trial?',
                zhHant: '可以免費試用多久呢?',
                ja: '無料トライアルはどのくらい使えますか？',
                ko: '무료 체험은 얼마나 할 수 있나요?'
              },
              answer: {
                en:
                  'Free trial on XRobotmon last for an hour. You can always come back to request for more free trial.<br><br>We build it this way so that everyone gets a chance to try the XRobotmon for free. Hope you have a great time playing with us!',
                zhHant: '免費試用版本每次試用時間為一小時，而在試用授權時間到期後，您仍可以繼續回來申請試用。',
                ja:
                  '無料トライアルは1回につき1時間ご利用いただけます。1回きりではなく、何度でもお申し込みいただけます。ただし、トライアル用のロボットはすべてのお客様で共有しているため、混み合う時間帯はすぐにご利用いただけないことがございます。その場合はお手数ですが、少し時間をおいてから再度お試しください。',
                ko:
                  '무료 체험은 한번에 한시간까지만 이용가능하며, 무료 체험 종료이후에도 다음날 다시 무료 체험을 시작 할 수 있습니다.'
              }
            }
          ]
        },
        {
          icon: 'mdi-gamepad-variant-outline',
          category: {
            en: 'Gaming',
            zhHant: '遊戲',
            ja: 'ゲーム',
            ko: '게임'
          },
          contents: [
            {
              expandKey: '#how-many-coins',
              question: {
                en: 'TsumTsum: How Many Coins Do I Really Have?',
                zhHant: 'TsumTsum: 我現在究竟有多少金幣？',
                ja: 'ツムツム：実際に持っているコイン数を確認するには？',
                ko: 'TsumTsum: 나는 실제로 얼마나 많은 코인을 가지고 있을까?'
              },
              answer: {
                en:
                  '<img src="/howmanycoins-en.jpg" width="100%" /><br />In Tsum Tsum, even though the main screen shows a coin limit of 99,999,999, your actual coin count can exceed this. To see your true balance, check the “My Data” section, where the real total is displayed, revealing that you can hold more coins than what’s shown on the main screen.',
                zhHant:
                  '<img src="/howmanycoins-zh.jpg" width="100%" /><br />在Tsum Tsum遊戲中，雖然主畫面顯示金幣數量上限為99,999,999，但實際上你的金幣總數可以超過這個數字。要查看你的真實金幣餘額，請前往「我的數據」頁面，這裡會顯示真實的金幣總數，揭示你可以持有的金幣比主畫面顯示的更多。',
                ja:
                  '<img src="/howmanycoins-ja.jpg" width="100%" /><br />ツムツムでは、メイン画面に表示されるコインの上限は99,999,999枚ですが、実際にはこれを超える枚数を保有できます。正確な所持数は、ゲーム内の［マイデータ］からご確認いただけます。メイン画面の表示を超えてコインが貯まっていることがお分かりいただけます。',
                ko:
                  '<img src="/howmanycoins-ko.jpg" width="100%" /><br />Tsum Tsum에서 메인 화면에는 코인 한도가 99,999,999으로 표시되지만 실제로는 이 숫자를 초과할 수 있습니다. 실제 잔액을 확인하려면 "내 데이터" 섹션을 확인하세요. 여기서 실제 총 코인 수를 볼 수 있으며, 메인 화면에 표시된 것보다 더 많은 코인을 보유할 수 있음을 알 수 있습니다。'
              }
            },
            {
              question: {
                en: 'XRobotmon cannot login to my Line: TsumTsum',
                zhHant: '我從直播看到我的Line: TsumTsum無法登入',
                ja: 'ライブ配信で、ツムツムにログインできない画面が表示されます',
                ko: '실시간 모니터링을 통해 라인 디즈니 썸썸의 게임 로그인이 안되고 있는 것을 확인한 경우.'
              },
              answer: {
                en:
                  "This error indicates that either your account or password is wrong. <br><br>'Line: TsumTsum' uses your Line *email* instead of Line ID to login. You will need to change the password in the XRobotmon setting page everytime you change the password.",
                zhHant:
                  '請注意帳號是輸入與Line綁定的Email，不是Line的ID。<br><br>另外如果有變更過密碼也請記得在XRobotmon設定頁面更新密碼。',
                ja:
                  'ログインに使うアカウントは、LINEのIDではなく、LINEに登録したメールアドレスです。また、LINEのパスワードを変更した場合は、Xロボットモンの設定ページでも新しいパスワードに更新してください。',
                ko:
                  '게임계정 아이디는 Line과 연동된 Email을 입력해주셔야 합니다. (Line의 아이디가 아닙니다.) 또한 게임계정의 비밀번호 변경이 있다면,  XRobotmon에서도 비밀번호를 갱신해야 합니다.'
              }
            },
            {
              question: {
                en: 'XRobotmon keep sending hearts, without auto playing',
                zhHant: '我的XRobotmon都只有在收送心，沒有自動玩',
                ja: 'Xロボットモンがハートの送受信ばかりで、自動プレイをしてくれません',
                ko: '하트를 보내기만 하고 자동으로 게임을 하지 않는 경우'
              },
              answer: {
                en:
                  "The reason that XRobotmon don't auto play is that, there are way too many friends that XRobotmon cannot finish sending hearts in an hour (including unknowns friends in the mail box).<br><br>XRobotmon will 1) try to receive all items every hours and 2) autoplay if there are some time left during mailbox item collection. So when you have too many friends that XRobotmon fails to receive all items within an hour, the XRobotmon will keep receiving items hourly so you won’t see it auto-playing.<br><br>If autoplay is preferred, it is recommended to limit the total friends number under 500, so that XRobotmon will have time playing the game :)",
                zhHant:
                  '如果朋友列表太多，在送心限制的一小時內XRobotmon可能會忙著收或送心而沒有空閒時間開始玩遊戲。如果真的想自動玩，建議將朋友數量控制在500人(包含Unknown)以內，如此一來當XRobotmon無心可收或送時，便會開始執行玩遊戲任務唷。',
                ja:
                  'Xロボットモンが1時間に送受信できるハートは約700個です。ランキングのお友達が700人を超えている場合は、ハートの送受信だけで1時間がいっぱいになってしまい、自動プレイまで手が回らないことがあります。ハートをすぐにお返しすることや、コインをこまめに受け取ることをあまり重視されない場合は、設定ページの［個別受け取りの間隔（分）］を初期値の1から10に変更してください。ハートの送受信にかかる時間に余裕が生まれ、その分だけ自動プレイを行えるようになります。',
                ko:
                  '친구 목록이 너무 많으면 하트 전송시간동안 XRobotmon에서 게임을 자동으로 시작하지 않을 수 있습니다. 게임 자동 플레이를 위해 게임 친구수는 500명내외를 유지를 권장합니다. XRobotmon이 자동으로 수령할 하트가 없을때 게임 플레이를 진행합니다.'
              }
            }
          ]
        }
      ]
    };
  },
  computed: {},
  mounted() {
    // find hashtag for expanding the panel
    for (let i = 0; i < this.qaList.length; i++) {
      for (let j = 0; j < this.qaList[i].contents.length; j++) {
        if (this.qaList[i].contents[j].expandKey === this.$route.hash) {
          this.panelLayer1 = i;
        }
      }
    }
  },
  methods: {
    back() {
      this.$router.push({ name: 'home' });
    }
  }
};
</script>